import _ from 'lodash';
import resolveComparator from './helpers/ComparatorResolver';
import { addItem } from '../../../../helpers/MapHelpers';
export function getFilterExpression(queryFilter) {
    if (queryFilter.hasComplexPropertyAccess) {
        var complexTypeIdentifierSplitted = queryFilter.property.split('<');
        var pathToTheComplexProperty_1 = complexTypeIdentifierSplitted[0];
        var complexTypeIdentifierEndSplitted = complexTypeIdentifierSplitted[1].split('>.');
        var complexPropertyKind = complexTypeIdentifierEndSplitted[0];
        var innerQueryFilter_1 = _.cloneDeep(queryFilter);
        // remove the any entry
        complexTypeIdentifierEndSplitted.splice(0, 1);
        innerQueryFilter_1.property = complexTypeIdentifierEndSplitted.join('>');
        switch (complexPropertyKind.toLowerCase()) {
            case 'any':
                return function (item) {
                    var proertyValue = _.get(item, pathToTheComplexProperty_1);
                    if (!proertyValue) {
                        return false;
                    }
                    return proertyValue.find(function (x) { return getFilterExpression(innerQueryFilter_1)(x); }) !== undefined;
                };
            default:
                throw new Error("Complex property kind " + complexPropertyKind + " is not implemented!");
        }
    }
    switch (queryFilter.comparator) {
        case resolveComparator('equals'):
            return function (item) { return _.get(item, queryFilter.property) === JSON.parse(queryFilter.value); };
        case resolveComparator('notEquals'):
            return function (item) { return _.get(item, queryFilter.property) !== JSON.parse(queryFilter.value); };
        case resolveComparator('contains'):
            return function (item) {
                var propetyValue = _.get(item, queryFilter.property);
                return propetyValue !== undefined && propetyValue.includes(JSON.parse(queryFilter.value));
            };
        case resolveComparator('containsIgnoreCase'):
            return function (item) {
                var _a;
                var propertyValue = _.get(item, queryFilter.property);
                return !!propertyValue && (propertyValue).toString().toLowerCase().includes((_a = JSON.parse(queryFilter.value)) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase());
            };
        case resolveComparator('startsWith'):
            return function (item) {
                var propertyValue = _.get(item, queryFilter.property);
                if (!propertyValue) {
                    return false;
                }
                return propertyValue.startsWith(JSON.parse(queryFilter.value));
            };
        case resolveComparator('startsWithIgnoreCase'):
            return function (item) {
                var propetyValue = _.get(item, queryFilter.property);
                return propetyValue !== undefined && propetyValue.toLowerCase().startsWith(JSON.parse(queryFilter.value).toLowerCase());
            };
        case resolveComparator('isOneOf'):
            return function (item) {
                var values = JSON.parse(queryFilter.value);
                var propertyValue = _.get(item, queryFilter.property);
                return values.find(function (x) { return x === propertyValue; }) !== undefined;
            };
        case resolveComparator('greaterThan'):
            return function (item) {
                var propetyValue = _.get(item, queryFilter.property);
                return propetyValue !== undefined && propetyValue > JSON.parse(queryFilter.value);
            };
        case resolveComparator('greaterThanEquals'):
            return function (item) {
                var propetyValue = _.get(item, queryFilter.property);
                return propetyValue !== undefined && propetyValue >= JSON.parse(queryFilter.value);
            };
        case resolveComparator('lowerThan'):
            return function (item) {
                var propetyValue = _.get(item, queryFilter.property);
                return propetyValue !== undefined && propetyValue < JSON.parse(queryFilter.value);
            };
        case resolveComparator('lowerThanEquals'):
            return function (item) {
                var propetyValue = _.get(item, queryFilter.property);
                return propetyValue !== undefined && propetyValue <= JSON.parse(queryFilter.value);
            };
        case resolveComparator('fuzzy'):
            // For fuzzy we expect that only the results from backend are in the data layer
            // We need a long term solution for that
            return function (_item) { return true; };
        case resolveComparator('isEmpty'):
            return function (item) {
                var propetyValue = _.get(item, queryFilter.property);
                return propetyValue !== undefined && propetyValue.length === 0;
            };
        case resolveComparator('isNotEmpty'):
            return function (item) {
                var propetyValue = _.get(item, queryFilter.property);
                return propetyValue !== undefined && propetyValue.length > 0;
            };
        default:
            console.error('The comparator of the query filter is currently not supported by getFilterExpression. Use => true as fallback', queryFilter);
            return function (_item) { return true; };
    }
}
export function getExpressionTreeNodeIdExpressionBuilder(expressionTreeNodeId) {
    var expressionIndicator = _.toInteger(expressionTreeNodeId % 10);
    switch (expressionIndicator) {
        case 0:
            return function (left, right) { return function (item) { return left(item) && right(item); }; };
        case 1:
            return function (left, right) { return function (item) { return left(item) || right(item); }; };
        default:
            throw new Error("The expression indicator " + expressionIndicator + " of expressionTreeNodeId " + expressionTreeNodeId + " is not supported");
    }
}
export function buildFilterExpression(queryFilters) {
    // create all expressions
    var queryFilterExpressions = new Map();
    queryFilters.forEach(function (x) { return queryFilterExpressions.set(x, getFilterExpression(x)); });
    // create a node for each expression group
    var previousLevelGroupsExpressions = new Map();
    // get levels and order them from bottom to top
    var levels = _.orderBy(_.groupBy(queryFilters, function (x) { return x.levelId; }), function (x) { return x[0].levelId; }, 'desc');
    // build nodes for each level
    levels.forEach(function (level) {
        var groupsOfLevel = _.groupBy(level, function (x) { return x.groupId; });
        Object.keys(groupsOfLevel).forEach(function (groupId) {
            var group = groupsOfLevel[groupId];
            var parentGroupId = group[0].parentGroupId;
            var itemsInGroup = group.length;
            var groupIdAsInt = _.toInteger(groupId);
            var subLevelGroupExpressions = previousLevelGroupsExpressions.get(groupIdAsInt);
            previousLevelGroupsExpressions.delete(groupIdAsInt);
            var hasSublevelExpressions = subLevelGroupExpressions !== undefined;
            if (itemsInGroup === 1 && !hasSublevelExpressions) {
                addItem(previousLevelGroupsExpressions, parentGroupId, queryFilterExpressions.get(group[0]));
                return;
            }
            var expressionBuilderOfGroup = getExpressionTreeNodeIdExpressionBuilder(group[0].expressionTreeNodeId);
            if (itemsInGroup === 1 && subLevelGroupExpressions && subLevelGroupExpressions.length === 1) {
                addItem(previousLevelGroupsExpressions, parentGroupId, expressionBuilderOfGroup(queryFilterExpressions.get(group[0]), subLevelGroupExpressions[0]));
                return;
            }
            var partialExpression = expressionBuilderOfGroup(queryFilterExpressions.get(group[0]), queryFilterExpressions.get(group[1]));
            for (var i = 2; i < group.length; i++) {
                partialExpression = expressionBuilderOfGroup(partialExpression, queryFilterExpressions.get(group[i]));
            }
            if (subLevelGroupExpressions) {
                subLevelGroupExpressions.forEach(function (x) {
                    partialExpression = expressionBuilderOfGroup(partialExpression, x);
                });
            }
            addItem(previousLevelGroupsExpressions, parentGroupId, partialExpression);
        });
    });
    var root = previousLevelGroupsExpressions.get(0);
    if (!root) {
        return function () { return true; };
    }
    return root[0];
}
function compareDates(a, b) {
    return a.getTime() - b.getTime();
    // Compare two dates (could be of any type supported by the convert
    // function above) and returns:
    //  -1 : if a < b
    //   0 : if a = b
    //   1 : if a > b
    // NaN : if a or b is an illegal date
    // NOTE: The code inside isFinite does an assignment (=).
    // @ts-ignore you can calculate with bool
    return (a > b) - (a < b);
}
function applyQueryParameters(target, queryParameters) {
    // first build filter expression
    var filterExpression = buildFilterExpression(queryParameters.filters);
    var filtered = target.filter(filterExpression);
    var sorted = queryParameters.hasSorting ? filtered.sort(function (a, b) {
        for (var i = 0; i < queryParameters.sortings.length; i++) {
            var querySorting = queryParameters.sortings[i];
            var proertyAccessor = _.property(querySorting.orderBy);
            var aValue = proertyAccessor(a);
            var bValue = proertyAccessor(b);
            // ToDo: make more generic somehow...
            var handleZeroAsUndefined = querySorting.orderBy.endsWith('rating')
                || querySorting.orderBy.endsWith('commentCount')
                || querySorting.orderBy.endsWith('versionCount');
            if (handleZeroAsUndefined) {
                if (!aValue) {
                    aValue = undefined;
                }
                if (!bValue) {
                    bValue = undefined;
                }
            }
            //#region sort undefined always last
            if (aValue === undefined) {
                return 1;
            }
            if (bValue === undefined) {
                return -1;
            }
            //#endregion
            if (aValue !== bValue) {
                // ToDo: do more testing on different data types, currently just string is tested
                var compareResult = 0;
                if (_.isDate(aValue)) {
                    compareResult = compareDates(aValue, bValue);
                }
                else if (_.isNumber(aValue)) {
                    compareResult = aValue - bValue;
                }
                else {
                    var aValueAsString = aValue === null || aValue === void 0 ? void 0 : aValue.toString();
                    compareResult = aValueAsString && aValueAsString.localeCompare ? aValueAsString.localeCompare(bValue === null || bValue === void 0 ? void 0 : bValue.toString()) : 0;
                }
                if (querySorting.isDescending) {
                    compareResult *= -1;
                }
                return compareResult;
            }
        }
        return 0;
    }) : filtered;
    // ToDo: locally I think we don't need take count
    //  const indexOfLast = queryParameters.lastId === undefined ? queryParameters.take - 1 : _.findIndex(sorted, x => x.id === queryParameters.lastId);
    // return sorted.slice(0, indexOfLast + 1);;
    return sorted;
}
export default applyQueryParameters;
//# sourceMappingURL=ExpressionBuilder.js.map